import { Checkbox, ContextualMenu, DefaultButton, IconButton, IDragOptions, Modal, Stack, Text } from "@fluentui/react";
import React, { ReactNode, useState } from "react";
import { descriptionStyles, lgDescriptionStyles, lgTitleStyles, mdDescriptionStyles, mdTitleStyles, modalContentStyles, modalIconButtonStyles, registerScenarioRowCheckboxStyles, registerScenarioRowContainerSelectedStyles, registerScenarioRowContainerStyles, registerScenarioRowInnerContainerSelectedStyles, registerScenarioRowTextContainerStyles, registerScenarioSuggestButtonStyles, smDescriptionStyles, smTitleStyles, titleStyles, xlDescriptionStyles, xlTitleStyles, xxlDescriptionStyles, xxlTitleStyles } from "../Styles/RegisterScenarioStyles";
import MediaQuery from "react-responsive";
import { Breakpoint, BreakpointType, GetBreakpoint } from "../../../../Container/ContainerFluid";
import { useBreakpoint } from "../../../../Container/ContainerStyles";
import { RegisterService } from "../../../Service/RegisterService";

export interface IRegisterScenarioRowProps {
    title: string;
    description: string;
    suggestText: string;
    selected: boolean;
    onChange: (selected: boolean) => void;
    onOpenSuggestModal: (content: string) => void;
}

export const RegisterScenarioRow: React.FC<IRegisterScenarioRowProps> = (props) => {
    const [breakpointsm] = useState<Breakpoint>(GetBreakpoint(BreakpointType.sm));
    const [breakpointmd] = useState<Breakpoint>(GetBreakpoint(BreakpointType.md));
    const [breakpointlg] = useState<Breakpoint>(GetBreakpoint(BreakpointType.lg));
    
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    return (
        <Stack
            className={props.selected ? registerScenarioRowContainerSelectedStyles : registerScenarioRowContainerStyles}
            onClick={() => props.onChange(!props.selected)}
        >
            <Stack
                horizontal
                horizontalAlign="space-between"
                verticalAlign="center"
                verticalFill
                className={props.selected ? registerScenarioRowInnerContainerSelectedStyles : undefined}
            >
                <Stack
                    horizontal
                    horizontalAlign="start"
                    verticalAlign="center"
                    verticalFill

                    className={registerScenarioRowTextContainerStyles}
                >
                    <Checkbox
                        styles={registerScenarioRowCheckboxStyles}
                        checked={props.selected}
                        onChange={() => props.onChange(!props.selected)}
                        checkmarkIconProps={{ iconName: 'LocationDot'}}
                    />
                    <Stack
                        verticalFill
                        verticalAlign="center"
                    >
                        <Text
                            className={
                                isSM ? 
                                    smTitleStyles : 
                                isMD ? 
                                    mdTitleStyles :
                                isLG ?
                                    lgTitleStyles :
                                isXL ?
                                    xlTitleStyles :
                                isXXL ?
                                    xxlTitleStyles
                                :
                                    titleStyles
                            }
                        >
                            {props.title}
                        </Text>
                        <Text
                            className={
                                isSM ? 
                                    smDescriptionStyles : 
                                isMD ? 
                                    mdDescriptionStyles : 
                                isLG ?
                                    lgDescriptionStyles :
                                isXL ?
                                    xlDescriptionStyles :
                                isXXL ?
                                    xxlDescriptionStyles
                                :
                                    descriptionStyles
                            }
                        >
                            {props.description}
                        </Text>
                    </Stack>
                </Stack>
                <Stack>
                    <MediaQuery
                        minWidth={breakpointlg.minWidth || breakpointlg.minWidth}
                    >
                        <DefaultButton
                            styles={registerScenarioSuggestButtonStyles}
                            iconProps={{ iconName: 'Info' }}
                            onClick={() => props.onOpenSuggestModal(props.suggestText)}
                        >
                           {RegisterService.translate("scenario:infoText")}
                        </DefaultButton>
                    </MediaQuery>
                    <MediaQuery
                        maxWidth={breakpointsm.maxWidth || breakpointmd.maxWidth}
                    >
                        <IconButton
                            iconProps={{ iconName: 'Info' }}
                            onClick={() => props.onOpenSuggestModal(props.suggestText)}
                        />
                    </MediaQuery>
                </Stack>
            </Stack>
        </Stack>
    );
};